"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiEduAgeRangesClient = void 0;
const ApiSubClient_1 = require("../../common/client/ApiSubClient");
class ApiEduAgeRangesClient extends ApiSubClient_1.ApiSubClient {
    async getAll() {
        const eduLink = this.getLinkOrThrow('ageRanges');
        return this.axios
            .get(eduLink.href)
            .then((eduResponse) => eduResponse.data._embedded.ageRanges)
            .then((ageRanges) => ageRanges.map((ageRange) => ({
            id: ageRange.id,
            min: ageRange.min,
            max: ageRange.max,
            label: ageRange.label,
        })));
    }
}
exports.ApiEduAgeRangesClient = ApiEduAgeRangesClient;
//# sourceMappingURL=ApiEduAgeRangesClient.js.map